import { useState } from "react";
import { api } from "../../../../../utils/api";
import { isAxiosError } from "axios";

interface ValidationRequest {
  message: string;
}

export const useRequestResetPassword = () => {
  const [isValid, setIsValid] = useState<boolean | null>(null);
  const [validationRequestUrl, setValidationRequestUrl] =
    useState<ValidationRequest | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const updatePassword = async (email: string) => {
    if (!email) return;

    setLoading(true);
    setError(null);
    setIsValid(null);

    try {
      const res = await api.post(`/auth-user/request-reset-password`, {
        email,
      });
      setValidationRequestUrl(res.data);
      setIsValid(true);
      return res.data;
    } catch (err) {
      let backendError = "Unknown error";
      if (isAxiosError(err)) {
        backendError =
          err.response?.data?.errors?.code ||
          err.response?.data?.message ||
          err.message;
      } else if (err instanceof Error) {
        backendError = err.message;
      }
      setError(backendError);
      setIsValid(false);
      // кидаємо помилку, щоб її можна було обробити у формі
      throw new Error(backendError);
    } finally {
      setLoading(false);
    }
  };

  return { updatePassword, validationRequestUrl, loading, error, isValid };
};
